export default "__VITE_ASSET__CbcriIcG__"